export default __webpack_public_path__ + "static/media/hero-video2.31a20652.mp4";